import React, { Component } from 'react';
import { post } from '../../utils/http';
import api from '../../utils/api';
import CreateNewMenu from './CreateNewMenu';
import EditDetailInformation from './EditDetailInformation'
import { Table, Button, Popconfirm, Pagination, notification, Input } from 'antd';
import { AppstoreAddOutlined } from '@ant-design/icons'

const { Search } = Input;

class MenuManagement extends Component {
    constructor(props) {
        super(props)
        this.state = {
            current: 1,
            pageSize: 10,
            total: 0,
            isOpenCreate: false,
            isOpenEdit: false,
            data: [],
            search: "",
            loading: false,
            editMenu: {},
        }
    }



    openCreateModal = () => {
        this.setState({ isOpenCreate: true })
    }

    closeCreateModal = () => {
        this.setState({ isOpenCreate: false })
    }

    openEditModal = (record) => {
        this.setState({ isOpenEdit: true, editMenu: record })
    }

    closeEditModal = () => {
        this.setState({ isOpenEdit: false })
    }

    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage }, () => {
            this.searchUser(false)
        })
    };

    getSearch = (value) => {
        this.setState({ loading: true, search: value }, () => {
            this.handleSearch(true)
        })
    };

    handleChangePage = (current, pageSize) => {
        this.setState({ current: current, pageSize: pageSize, loading: true }, () => {
            this.handleSearch(false)

        })
    }

    handleDel = (menuId) => {
        this.setState({ loading: true })
        var delData = new FormData();
        delData.append("menuId", menuId);
        var _this = this;
        post(api.delMenu, delData).then(function (response) {
            notification['success']({
                message: 'Delete successfully.',
            });
            _this.handleSearch(true);
        }).catch(function (error) {
            notification['error']({
                message: 'Fail to delete.',
            });
            _this.setState({ loading: false })
            console.log('error', error);
        })
    }

    handleSearch = (flag) => {

        this.setState({ loading: true })
        var _this = this;
        let { search, pageSize, current } = this.state;
        let data;
        if (flag) {
            data = { pageNum: 1, pageSize: pageSize, search: search }
        } else {
            data = { pageNum: current, pageSize: pageSize, search: search }
        }

        post(api.menuList, data).then(function (response) {
            var { total, currentPage, pageSize, rows } = response

            _this.setState({
                current: currentPage,
                pageSize: pageSize,
                total: total,
                data: rows,
                loading: false
            }
            )
        }).catch(function (error) {
            notification['error']({
                message: 'Fail to search.',
            });
            console.log(error)
            _this.setState({
                loading: false
            })
        })
    }


    columns = [
        {
            title: 'MenuName',
            key: 'menuName',
            dataIndex: 'menuName',
            fixed: 'left',
            width: 200,
            // render: text => <span style={{ cursor: 'pointer', color: 'red' }} >{text}</span>,
        }, {
            title: 'MenuPath',
            key: 'menuPath',
            width: 260,
            dataIndex: 'menuPath',
        }, {
            title: 'Component',
            key: 'component',
            width: 200,
            dataIndex: 'component',
        }, {
            title: 'Status',
            key: 'status',
            width: 120,
            dataIndex: 'status',
            render: text => <span>{text === '1' ? 'valid' : 'invalid'}</span>
        }, {
            title: 'CreateBy',
            key: 'createBy',
            width: 120,
            dataIndex: 'createBy'
        }, {
            title: 'CreateDate',
            key: 'createDate',
            width: 260,
            dataIndex: 'createDate'
        }, {
            title: 'UpdateBy',
            key: 'updateBy',
            width: 120,
            dataIndex: 'updateBy'
        }, {
            title: 'UpdateDate',
            key: 'updateDate',
            width: 260,
            dataIndex: 'updateDate'
        }, {
            align:'center',
            title: 'Action',
            key: 'Action',
            fixed: 'right',
            width: 220,
            render: (_, record) => {
                return (
                    <div style={{ display: 'flex' }}>
                        <Button type='primary' shape="round" style={{ marginRight: '10px' }} onClick={() => { console.log("asdfasdfasf"); this.openEditModal(record) }} >Edit</Button>
                        <Popconfirm title="Are you sure to delete this menu?" onConfirm={() => this.handleDel(record.menuId)}>
                            <Button type='primary' shape="round">Delete</Button>
                        </Popconfirm>
                    </div>
                )
            }
        },
    ];

    componentWillMount() {
        this.handleSearch(true)
    }

    render() {
        const { data, current, total, loading } = this.state;
        return (
            <div>
                <div style={{ backgroundColor: "white", display: "flex", justifyContent: "space-between", marginBottom: "10px", padding: "20px" }}>
                    <Search size="large" placeholder="Search menu name" onSearch={this.getSearch} style={{ width: '400px' }} />
                    <Button icon={<AppstoreAddOutlined />} type="primary" size="large" onClick={this.openCreateModal}> New Menu</Button>
                </div>

                <Table
                    scrollToFirstRowOnChange={true}
                    scroll={{ x: '100%', y: 360 }}
                    columns={this.columns}
                    rowKey={record => record.menuId}
                    dataSource={data}
                    pagination={false}
                    loading={loading} />
                <Pagination style={{ marginTop: '5px' }} current={current} showSizeChanger={true} total={total} onChange={this.handleChangePage} />

                <CreateNewMenu isOpenCreate={this.state.isOpenCreate} closeCreateModal={this.closeCreateModal} handleSearch={this.handleSearch} />
                {this.state.isOpenEdit && <EditDetailInformation isOpenEdit={this.state.isOpenEdit} closeEditModal={this.closeEditModal} handleSearch={this.handleSearch} editValue={this.state.editMenu} />}
            </div>
        )
    }

}
export default MenuManagement;